import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CreateHotel from "./CreateHotel";
import EditHotel from "./EditHotel";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { getAllHotels, deleteHotels } from "../../api/Hotels";
import "../../vendor/css/viewhotels.css";

const ViewHotels = () => {
  const [hotelsList, setHotelsList] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const hotelsPerPage = 10;

  useEffect(() => {
    const getHotelsList = async () => {
      try {
        const response = await getAllHotels();
        setHotelsList(response?.hotels || response || []);
      } catch (error) {
        console.error("Error fetching hotels:", error);
        Swal.fire("Error", "Failed to load hotels", "error");
      } finally {
        setLoading(false);
      }
    };
    getHotelsList();
    const interval = setInterval(getHotelsList, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  // create and edit model state defind here
  const [createHotelsModalshow, setCreateHotelsModalshowShow] = useState(false);
  const handleCreateModalClose = () => setCreateHotelsModalshowShow(false);
  const handleCreateModalShow = () => setCreateHotelsModalshowShow(true);
  const [editHotelsModelShow, setEditHotelsModelShow] = useState(false);
  const handleEditModalClose = () => setEditHotelsModelShow(false);
  const handleEditModalShow = () => setEditHotelsModelShow(true);

  // Filter hotels based on search term
  const filteredHotels = hotelsList.filter(hotel =>
    hotel.hotel_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastHotel = currentPage * hotelsPerPage;
  const indexOfFirstHotel = indexOfLastHotel - hotelsPerPage;
  const currentHotels = filteredHotels.slice(indexOfFirstHotel, indexOfLastHotel);
  const totalPages = Math.ceil(filteredHotels.length / hotelsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeleteHotels = (hotelToDelete) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteHotels(hotelToDelete)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              setHotelsList((prev) =>
                prev.filter((item) => item._id !== hotelToDelete._id)
              );
            }
          })
          .catch((err) => {
            console.error("Delete failed:", err);
            Swal.fire("Error", "Failed to delete hotel", "error");
          });
      }
    });
  };

  if (loading) {
    return (
      <div className="view-hotels">
        <div className="hotels-header">
          <h1>Hotels Management</h1>
          <p>Manage and view all hotel listings</p>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading hotels...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="view-hotels">
      <div className="hotels-header">
        <h1 style={{ fontFamily: 'serif' }}>Hotels Management</h1>
        <p style={{ fontFamily: 'serif' }}>Manage and view all hotel listings</p>
      </div>

      <div className="hotels-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-building-house"></i>
          </div>
          <div className="stat-content">
            <h3>{hotelsList.length}</h3>
            <p>Total Hotels</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-search"></i>
          </div>
          <div className="stat-content">
            <h3>{filteredHotels.length}</h3>
            <p>Filtered Results</p>
          </div>
        </div>
      </div>

      <div className="hotels-controls">
        <div className="search-container">
          <i className="bx bx-search search-icon"></i>
          <input
            type="text"
            placeholder="Search by hotel name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <button
          className="btn btn-primary add-hotel-btn"
          onClick={handleCreateModalShow}
        >
          <i className="bx bx-plus"></i>
          Add Hotel
        </button>
      </div>

      <div className="hotels-grid">
        {currentHotels.length > 0 ? (
          currentHotels.map((hotel, index) => (
            <div key={hotel._id || index} className="hotel-card">
              <div className="hotel-image">
                <img
                  src={hotel.image}
                  alt={hotel.hotel_name}
                  onError={(e) => {
                    e.target.src = '/assets/images/placeholder.png';
                  }}
                />
              </div>
              <div className="hotel-info">
                <h3>{hotel.hotel_name}</h3>
                <div className="hotel-contact">
                  <div className="contact-item">
                    <i className="bx bx-phone"></i>
                    <a href={`tel:${hotel.phone_no}`}>{hotel.phone_no}</a>
                  </div>
                  <div className="contact-item">
                    <i className="bx bx-envelope"></i>
                    <a href={`mailto:${hotel.email}`}>{hotel.email}</a>
                  </div>
                </div>
                <p className="hotel-description">{hotel.introduction}</p>
                <div className="hotel-actions">
                  <button
                    className="btn btn-primary edit-btn"
                    onClick={() => {
                      setSelectedHotel(hotel);
                      handleEditModalShow();
                    }}
                    title="Edit Hotel"
                  >
                    <i className="bx bx-edit"></i>
                    Edit
                  </button>
                  <button
                    className="btn btn-danger delete-btn"
                    onClick={() => handleDeleteHotels(hotel)}
                    title="Delete Hotel"
                  >
                    <i className="bx bx-trash"></i>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <div className="no-data-content">
              <i className="bx bx-building-house-x"></i>
              <p>No hotels found</p>
              <small>Try adjusting your search criteria</small>
            </div>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-left"></i>
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-right"></i>
          </button>
        </div>
      )}

      {/* Create Hotel Modal */}
      <Modal
        show={createHotelsModalshow}
        onHide={handleCreateModalClose}
        className="hotel-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Hotel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateHotel
            onSuccess={(res) => {
              console.log(res);
              setCreateHotelsModalshowShow(false);
              setHotelsList(res?.hotel || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCreateModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Hotel Modal */}
      <Modal
        show={editHotelsModelShow}
        onHide={handleEditModalClose}
        className="hotel-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Hotel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditHotel
            hotel={selectedHotel}
            onSuccess={(res) => {
              setEditHotelsModelShow(false);
              setHotelsList(res?.hotel || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewHotels;
